import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DictEntryModel } from '../models/dict-entry.model';
import { SearchResultModel } from '../models/search-result.model';
import { SuggestionModel } from '../models/suggestion.model';
import { HttpService } from './http.service';
import { SpellSuggestionModel } from '../models/spell-suggestion.model';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private http: HttpService) { }

  // search(term: string): Observable<SearchResultModel[]> {
  //   return this.http.get<SearchResultModel[]>(
  //     `${this.baseUrl}dict/search/${encodeURIComponent(term)}`,
  //   );
  // }

  suggestions(term: string): Observable<SuggestionModel> {
    return this.http.get<SuggestionModel>(
      `${environment.backendUrl}dict/morph/${encodeURIComponent(term)}`,
    );
  }

  spellSuggestions(term: string): Observable<SpellSuggestionModel> {
    return this.http.get<SpellSuggestionModel>(
      `${environment.backendUrl}dict/spellcheck/${encodeURIComponent(term)}`,
    );
  }

  word(word: string): Observable<DictEntryModel> {
    return this.http.get<DictEntryModel>(
      `${environment.backendUrl}dict/word/${encodeURIComponent(word)}`,
    );
  }

}
